import { useState } from "react";
import { DatabaseBtn } from "../../../../utils/constants";
import ButtonGroup from "../../../common/ButtonGroup";
import Customers from "./Customers";
import Orders from "./Orders";
import Statistics from "./Statistics";

const Database = () => {
  const [selected, setSelected] = useState("orders");

  const handleButtonClick = (value) => {
    setSelected(value);
  };
  return (
    <>
      <main>
        <div className="">
          <ul className="flex items-center gap-3 mb-3">
            <ButtonGroup
              buttons={DatabaseBtn}
              boxClass="flex-1"
              onButtonClick={handleButtonClick}
              selected={selected}
            />
          </ul>

          {selected === "orders" && <Orders />}
          {selected === "customers" && <Customers />}
          {selected === "statistics" && <Statistics />}
        </div>
      </main>
    </>
  );
};

export default Database;
